if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) {
        const firstActive = this.elements.viewer?.querySelector('.product__media-item.is-active');
        if (firstActive) this.playActiveMedia(firstActive);
        return;
      }

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 100));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();

      if (this.dataset.verticallyCenter === 'true' && this.mql.matches) {
        this.stickyHeader = document.querySelector('.shopify-section-header');
        this.stickyCart = document.querySelector('.product-sticky-cart');
        this.ticking = false;

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
      }

      const firstActive = this.elements.viewer?.querySelector('.product__media-item.is-active');
      if (firstActive) this.playActiveMedia(firstActive);
    }

    onScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          if (this.mql.matches) {
            this.updateMediaGalleryPosition();
          }
          this.ticking = false;
        });

        this.ticking = true;
      }
    }

    updateMediaGalleryPosition() {
      if (window.scrollY < 20) {
          this.style.top = `${this.stickyHeader?.offsetHeight || 0}px`;
          return;
      }

      const viewportHeight = window.innerHeight;
      const cartHeight = this.stickyCart?.offsetHeight || 0;
      const mediaHeight = this.offsetHeight || 0;

      let headerHeight = this.stickyHeader?.offsetHeight || 0;
      if (this.stickyHeader?.classList.contains('shopify-section-header-hidden') || !this.stickyHeader?.classList.contains('shopify-section-header-sticky')) {
        headerHeight = 0;
      }

      const availableSpace = viewportHeight - headerHeight - cartHeight;
      const topOffset = headerHeight + (availableSpace - mediaHeight) / 2;

      this.style.top = `${Math.max(headerHeight, topOffset)}px`;
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      this.playActiveMedia(event.detail.currentElement);

      const thumbnail = this.elements.thumbnails
        ? this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`)
        : null;
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();

      const inlineAutoplayVideo = activeItem.querySelector('deferred-media[data-inline-autoplay] video');
      if (inlineAutoplayVideo) {
        inlineAutoplayVideo.play().catch(() => {});
        return;
      }

      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) {
        if (deferredMedia.hasAttribute('loaded')) {
          const v = deferredMedia.querySelector('video');
          if (v) v.play().catch(() => {});
        } else {
          deferredMedia.loadContent(false);
          const v = deferredMedia.querySelector('video');
          if (v) v.play?.();
        }
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
